/**
 * Маска ввода для productsDescription:
 * - не более одного пробела подряд;
 * - пробелы и переносы строк в начале обрезаются при вводе.
 */
export const parseProductsDescription = (value: string | undefined) => {
  if (value == null) {
    return value;
  }

  return value.replace(/ {2,}/g, ' ').replace(/^[\n\r ]+/, '');
};

/**
 * Финальная нормализация (blur / сохранение):
 * - пробелы и переносы строк в начале и конце;
 * - не более одного пробела подряд.
 */
export const normalizeProductsDescription = (value: string | undefined | null) => {
  if (value == null) {
    return value;
  }

  const normalized = value.replace(/ {2,}/g, ' ').replace(/^[\n\r ]+|[\n\r ]+$/g, '');

  return normalized === '' ? undefined : normalized;
};
